import './portfolioItem.scss';
import linkImg from '../../img/link.svg';
import { useState } from 'react';

function PortfolioItem(props) {
  const [display1, setDisplay1] = useState('block');
  const [display2, setDisplay2] = useState('none');

  function hoverOnItem(hover) {
    if (hover) {
      setDisplay1('none');
      setDisplay2('block');
    }
    else if (!hover) {
      setDisplay1('block');
      setDisplay2('none');
    }
  }


  return (
    <div className='portfolioItem'>
      <img style={{ display: `${display1}` }} className='portfolioItem__img' src={props.img} alt={props.alt} onMouseEnter={() => hoverOnItem(true)}></img>
      <div style={{ display: `${display2}` }} className='portfolioItem__info' onMouseLeave={() => hoverOnItem(false)}>
        <h3 className='portfolioItem__info__header'> {props.header} </h3>
        <p className='portfolioItem__info__descr'> {props.descr} </p>
        <a href={props.link} target='_blank' rel="noreferrer">
          <input className='portfolioItem__info__btn' src={linkImg} type='image' alt='link'>
          </input>
        </a>
      </div>
    </div>
  );
}

export default PortfolioItem;